import SignatureScreen from './SignatureScreen.js';
//holao
export default SignatureScreen;
